/* DEPRECATED component */
import * as React from 'react';

import './ButtonWithUnderlay.css';

export enum ButtonColor {
  DEFAULT = 'DEFAULT',
  LIGHT = 'LIGHT',
  WHITE = 'WHITE',
}

interface ButtonWithUnderlayProps {
  width?: string;
  label: string;
  color?: ButtonColor;
  onClick?: (args?: any) => void;
  disabled?: boolean;
}

interface ButtonWithUnderlayState {
  colorClassButton: string;
  colorClassSpan: string;
}

export default class ButtonWithUnderlay extends React.Component<
  ButtonWithUnderlayProps,
  ButtonWithUnderlayState
> {
  constructor({ props }: { props: any }) {
    super(props);
    this.state = {
      colorClassButton: 'ButtonWithUnderlay__Color_default',
      colorClassSpan: 'ButtonWithUnderlay__Font_color',
    };
  }

  public componentDidMount(): void {
    console.warn('component <ButtonWithUnderlay> is deprecated, use <Button>!');
    const { color } = this.props;
    if (color) {
      switch (color) {
        case ButtonColor.LIGHT:
          this.setState({
            colorClassButton: 'ButtonWithUnderlay__Color_light',
            colorClassSpan: 'ButtonWithUnderlay__Font_color_light',
          });
          break;
        case ButtonColor.WHITE:
          this.setState({
            colorClassButton: 'ButtonWithUnderlay__Color_white',
            colorClassSpan: 'ButtonWithUnderlay__Font_color_light',
          });
          break;
      }
    }
  }

  /*Переписать на нормальный button*/
  public render() {
    const { label, onClick, width, disabled } = this.props;
    const { colorClassButton, colorClassSpan } = this.state;

    return (
      <button
        className={`ButtonWithUnderlay ${colorClassButton}`}
        style={{ width }}
        onClick={onClick}
        disabled={disabled}
      >
        <span className={`ButtonWithUnderlay__Font ${colorClassSpan}`}>{label}</span>
      </button>
    );
  }
}
